// extracted by mini-css-extract-plugin
module.exports = {"ImageSlider":"ImageSlider_ImageSlider__14DVx","Slider":"ImageSlider_Slider__29OWl","Image":"ImageSlider_Image__2kcKa","Transparent":"ImageSlider_Transparent__3I1BE"};